import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import PrivateRoute from '../../PrivateRoute';

export const MeridianPage = lazy(() => import('pages/Meridian/Meridian'));
export const MeridianDetailPage = lazy(() => import('pages/Meridian/MeridianDetail'));

export default function MeridianRoutes() {
  return (
    <Routes>
      <Route
        path="/meridian"
        element={
          <PrivateRoute>
            <MeridianPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/meridian/:id"
        element={
          <PrivateRoute>
            <MeridianDetailPage />
          </PrivateRoute>
        }
      />
    </Routes>
  );
}
